import { render, staticRenderFns } from "./TagsIcon.vue?vue&type=template&id=fc98e96e&"
import script from "./TagsIcon.vue?vue&type=script&lang=js&"
export * from "./TagsIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports